import React from 'react';
import LegacyBlock from '../components/LegacyBlock';
import CmsPage from './CmsPage';

const About = () => {
    return (
        <div>
            <CmsPage slug="about" titleFallback="About">
                <LegacyBlock />
            </CmsPage>
        </div>
    );
};

export default About;
